import React, { useState, useEffect, useRef } from "react";
import { AutoComplete } from "primereact/autocomplete";
import {
  GET_SCHEPASSENGER_LIST,
  GET_LOCATION_URL,
  GET_DRIVER_URL,
  ADD_SCHEDULE_URL,
  ADD_SCHEDULE_V1_URL,
  CHECK_DRIVER_AVAILABILITY,
  GET_NEMT_SERVICES_V1,
  GET_SERVICE_AUTH_ACTIVE,
  GET_DRIVER_URL_V1
} from "../constant";
import axios from "axios";
//import Swal from '../../node_modules/sweetalert2/dist/sweetalert2';
import {
  dateFormat,
  restrictNumberInput,
  onlyNumberInput,
  restrictSpecialCharacters,
} from "../utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import TimePicker from '../components/TimePicker';
import PopupModal from "../components/popupModal";
import ReusableModal from "../components/ModalContent/ReusableModal";
import EditLocationContent from "../components/ModalContent/EditLocationContent";
import EditableDropDown from "../components/EditableDropDown";
import calender from "../assets/images/calendar.png";
import SelectDropDown from "../components/SelectDropDown";
import SaveButton from "../components/buttons/SaveButton";
import CancelButton from "../components/buttons/CancelButton";
import { currentDateFormat } from "../utils";
import { useNavigate } from "react-router-dom";
import {
  scheduleFormValidation,
  validateAccordion,
  validateLegs,
} from "../validation/Validation";
import { Circles } from "react-loader-spinner";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../redux/loaderAction";
import Loader from "../components/loader/Loader";
import { TimeInput } from "@nextui-org/react";
import moment from "moment";
import Swal from "../messageBox/customSweetAlert";
//import { useEffect, useState } from 'react';

const GOOGLE_MAPS_API_KEY = "AIzaSyCzII2bsnbbxWr7O31YyG0Q1BOeWS_sjiI";

const loadGoogleMapsScript = (apiKey) => {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = (error) => reject(error);
    document.head.appendChild(script);
  });
};

const toRadians = (degrees) => degrees * (Math.PI / 180);

const calculateHaversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c * 0.621371;
};

const buildLocationAddress = (location) => {
  if (!location) return "";
  return `${location.loc_address}, ${location.loc_city}, ${location.state?.state_name ?? ""}, ${location.loc_zip}`;
};

const geocodeAddress = async (address) => {
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${GOOGLE_MAPS_API_KEY}`,
  );
  const data = await response.json();
  if (data.status !== "OK") {
    throw new Error(`Geocoding failed: ${data.status}`);
  }
  return data.results[0].geometry.location;
};

// Precompute 5-minute interval time options in 12-hour format (e.g., "01:05 AM")
const TIME_OPTIONS_5_MIN = (() => {
  const times = [];
  for (let hour = 0; hour < 24; hour++) {
    for (let minute = 0; minute < 60; minute += 5) {
      const period = hour < 12 ? "AM" : "PM";
      const hour12 = hour % 12 === 0 ? 12 : hour % 12;
      const hourStr = String(hour12).padStart(2, "0");
      const minuteStr = String(minute).padStart(2, "0");
      times.push(`${hourStr}:${minuteStr} ${period}`);
    }
  }
  return times;
})();

const UpdatedSchedule = () => {
  const prevAccordionsRef = useRef();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const datepickerRef = useRef(null);
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loader.loading);
  const [passengers, setPassengers] = useState([]);
  const [selectedPassenger, setSelectedPassenger] = useState({
    label: "",
    value: {},
  });
  const [filteredPassenger, setFilteredPassenger] = useState(null);
  const [location, setLocation] = useState([]);
  const [scheduleDate, setScheduleDate] = useState();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [assignedDriver, setAssignedDriver] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [pickUpLocation, setPickUplocation] = useState(null);
  const [dropOffLocation, setDropOffLocation] = useState(null);
  const [pickUpTime, setPickUpTime] = useState(null);
  const [dropOffTime, setDropOffTime] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [locationValue, setLocationValue] = useState({
    loc_address: "",
    loc_city: "",
    loc_name: "",
    loc_state: "",
    loc_type: "",
    loc_zip: "",
    pass_id: "",
  });
  const [scheduleDetails, setScheduleDetails] = useState({
    schedule_date: "",
    location_type: "",
    wheel_chair: "",
    stretcher: "",
    assigned_driver: "",
    number_of_leg: "2",
    bill_amount: "",
    date_mode: "single",
    // Wait time defaults
    hour: "00",
    minute: "00",
    frequency: "daily", // Add frequency field
    selectedDays: [], // Add selected days field
    has_companions: "No", // Add companion field
    companion_count: "", // Add companion count field
    transport_type: 2, // Add transport type field
    transport_option: "", // Add transport option field
    appt_time: "", // Add appt time field
    one_way: "1", // Set default to "No"
    ma_service_auth_id: "", // For MA payer: selected active service authorization id
    sa_number: null,
    diagnosis_code: null,
    service_rate_id: null,
  });
  //const [loading, setLoading] = useState(false);
  const [isAddingSchedule, setIsAddingSchedule] = useState(false);
  const [setValue, setSetValue] = useState(false);
  const [accordionsWithError, setAccordionsWithError] = useState([]);
  const [selectedPickUpLocations, setSelectedPickUpLocations] = useState({});
  const [isWait, setIsWait] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const [isEditingWaitHour, setIsEditingWaitHour] = useState(false);
  const [isEditingWaitMinute, setIsEditingWaitMinute] = useState(false);
  const [totalDistance, setTotalDistance] = useState("");
  const [pickupAddress, setPickupAddress] = useState("");
  const [dropoffAddress, setDropoffAddress] = useState("");
  const [allLocations, setAllLocations] = useState("");
  const [overlapedTimes, setOverlapedTimes] = useState([]);
  const [locationErrors, setLocationErrors] = useState({});
  const [hasCompanions, setHasCompanions] = useState("No");
  const [transportOptions, setTransportOptions] = useState([]);
  const [loadingTransportOptions, setLoadingTransportOptions] = useState(false);
  const [activeServiceAuthList, setActiveServiceAuthList] = useState([]);
  const [loadingActiveServiceAuth, setLoadingActiveServiceAuth] =
    useState(false);
  const [maServiceAuthError, setMaServiceAuthError] = useState("");
  const [locationTypes, setLocationTypes] = useState({});
  const [editLocationOpen, setEditLocationOpen] = useState(false);
  const [companionCount, setCompanionCount] = useState("");

  // New state variables for Leg 1 specific fields
  const [legOneDriver, setLegOneDriver] = useState("");
  const [legOneTripDate, setLegOneTripDate] = useState("");
  const [legOneRideId, setLegOneRideId] = useState("");
  const legOneDatepickerRef = useRef(null);
  const prevLeg1AssignedDriverRef = useRef("");
  /** Previous leg 1 scheduled miles (for syncing to other legs when they still match). */
  const prevScheduledMilesLeg1Ref = useRef("");

  const [numberOfLeg, setNumberOfLeg] = useState("2");
  const [disabledInput, setDisabledInput] = useState(true);
  const [frequency, setFrequency] = useState("daily");
  const [selectedDays, setSelectedDays] = useState([]);
  const [pickupLocationType, setPickupLocationType] = useState(false);
  const [dropoffLocationType, setDropoffLocationType] = useState(false);
  const [calculatingLeg1Mileage, setCalculatingLeg1Mileage] = useState(false);

  const uniqueAllLocations = React.useMemo(() => {
    if (!Array.isArray(allLocations)) return [];
    const seen = new Set();
    return allLocations.filter((locationItem) => {
      const locationId = String(locationItem?.loc_id ?? "");
      if (!locationId || seen.has(locationId)) return false;
      seen.add(locationId);
      return true;
    });
  }, [allLocations]);

  //ACCORDANCE
  const [maxLegs, setMaxLegs] = useState(0);
  const [accordions, setAccordions] = React.useState([
    {
      id: 1,
      expanded: true,
      pick_up_loc: "",
      number_of_leg: "2",
      assigned_driver: "",
      scheduled_miles: "",
      pickup_latitude: "",
      pickup_longitude: "",
      dropoff_latitude: "",
      dropoff_longitude: "",
    },
    {
      id: 2,
      expanded: false,
      pick_up_loc: "",
      number_of_leg: "2",
      assigned_driver: "",
      scheduled_miles: "",
      pickup_latitude: "",
      pickup_longitude: "",
      dropoff_latitude: "",
      dropoff_longitude: "",
    },
  ]);

  // Step 2: Function to add a new Accordion
  const handleAddAccordion = () => {
    if (accordions.length < maxLegs) {
      const newId = accordions.length + 1;
      setAccordions([
        ...accordions,
        {
          id: newId,
          expanded: false,
          assigned_driver: accordions?.[0]?.assigned_driver ?? "",
          scheduled_miles: accordions?.[0]?.scheduled_miles ?? "",
          pickup_latitude: "",
          pickup_longitude: "",
          dropoff_latitude: "",
          dropoff_longitude: "",
        },
      ]);
    }
  };

  // Step 3: Function to toggle an Accordion's expanded state
  const handleToggle = (id) => {
    setAccordions((prev) =>
      prev.map((accordion) =>
        accordion.id === id
          ? { ...accordion, expanded: true }
          : { ...accordion, expanded: false },
      ),
    );
  };

  // Step 4: Handle input changes for each Accordion
  const handleAccordianInputChange = async (id, field, value) => {
    if (field === "number_of_leg") {
      const numLegs = parseInt(value);
      setMaxLegs(numLegs);
      setNumberOfLeg(numLegs);

      const currentAccordionsLength = accordions.length;
      if (currentAccordionsLength < numLegs) {
        const leg1Driver = accordions?.[0]?.assigned_driver ?? "";
        // Adding new accordions - preserve existing data
        const leg1Miles = accordions?.[0]?.scheduled_miles ?? "";
        const newAccordions = Array.from(
          { length: numLegs - currentAccordionsLength },
          (_, index) => ({
            id: currentAccordionsLength + index + 1,
            expanded: false,
            pick_up_loc: "",
            drop_off_loc: "",
            pick_up_time: "",
            drop_off_time: "",
            ride_id: "",
            distance: 0,
            assigned_driver: leg1Driver,
            scheduled_miles: leg1Miles,
            pickup_latitude: "",
            pickup_longitude: "",
            dropoff_latitude: "",
            dropoff_longitude: "",
          }),
        );
        setAccordions([...accordions, ...newAccordions]);
      } else {
        // Reducing accordions - keep existing data for remaining accordions
        setAccordions([...accordions.slice(0, numLegs)]);
      }
      setScheduleDetails((prev) => ({
        ...prev,
        number_of_leg: numLegs,
        [field]: value,
      }));
    } else {
      if (field === "assigned_driver") {
        if (id === 1) {
          const prevLeg1 = prevLeg1AssignedDriverRef.current;
          prevLeg1AssignedDriverRef.current = value;
          setAccordions((prev) =>
            prev.map((acc) => {
              if (acc.id === 1) return { ...acc, assigned_driver: value };
              if (!acc.assigned_driver || acc.assigned_driver === prevLeg1) {
                return { ...acc, assigned_driver: value };
              }
              return acc;
            }),
          );
          return;
        }
        setAccordions((prev) =>
          prev.map((acc) =>
            acc.id === id ? { ...acc, assigned_driver: value } : acc,
          ),
        );
        return;
      }

      if (field === "scheduled_miles") {
        const sanitized = value
          .replace(/[^\d.]/g, "")
          .replace(/(\..*)\./g, "$1");
        if (id === 1) {
          const prevLeg1 = prevScheduledMilesLeg1Ref.current;
          prevScheduledMilesLeg1Ref.current = sanitized;
          setAccordions((prevAcc) =>
            prevAcc.map((acc) => {
              if (acc.id === 1) return { ...acc, scheduled_miles: sanitized };
              const shouldSync =
                acc.scheduled_miles === "" || acc.scheduled_miles === prevLeg1;
              return shouldSync ? { ...acc, scheduled_miles: sanitized } : acc;
            }),
          );
        } else {
          setAccordions((prev) =>
            prev.map((acc) =>
              acc.id === id ? { ...acc, scheduled_miles: sanitized } : acc,
            ),
          );
        }
        setErrors((prev) => {
          const next = { ...(prev || {}) };
          if (next[id]?.scheduled_miles) {
            next[id] = { ...next[id], scheduled_miles: null };
          }
          if (next.schedule_miles) delete next.schedule_miles;
          return next;
        });
        return;
      }

      // const newAcordionList = [];
      let localAccordions = [...accordions];

      localAccordions = localAccordions.map((accordion) => {
        if (accordion.id === id) {
          //console.log("localAccordions",id);
          const updatedAccordion = { ...accordion, [field]: value };
          // If updating Leg 1's pick_up_loc, update Leg 2's drop_off_loc (round trip linking)
          if (id === 1 && field === "pick_up_loc") {
            const leg2 = localAccordions.find((a) => a.id === 2);
            if (leg2) {
              localAccordions[1].drop_off_loc = value;
            }
          }
          // If updating Leg 1's drop_off_loc, update Leg 2's pick_up_loc (round trip linking)
          if (id === 1 && field === "drop_off_loc") {
            const leg2 = localAccordions.find((a) => a.id === 2);
            if (leg2) {
              localAccordions[1].pick_up_loc = value;
            }
          }
          return updatedAccordion;
        }
        return accordion;
      });
      localAccordions.forEach((accordion) => {
        const pickUp = accordion.pick_up_loc;
        const dropOff = accordion.drop_off_loc;

        if (pickUp && dropOff && Number(pickUp) === Number(dropOff)) {
          setLocationErrors((prev) => ({
            ...prev,
            [accordion.id]: "Pickup and Drop-off locations cannot be the same.",
          }));
        } else {
          setLocationErrors((prev) => {
            const newErrors = { ...prev };
            delete newErrors[accordion.id];
            return newErrors;
          });
        }
      });

      // if (((field === 'pick_up_time' || field === 'drop_off_time'))) {
      //   const isDriverAvailable = await checkDriverAvailability(scheduleDetails.assigned_driver, moment(scheduleDate).format('YYYY-MM-DD'), value);

      //   if (isDriverAvailable === '400') {
      //     //alert('The assigned driver is not available at the selected time.');
      //     setOverlapedTimes((prevOverlapedTimes) => [...prevOverlapedTimes, id]);
      //     Swal.fire({
      //       title: 'Failed!',
      //       text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",

      //       confirmButtonText: 'OK',
      //       allowOutsideClick: false
      //     });
      //     //return ;

      //   } else {
      //     setOverlapedTimes((prevOverlapedTimes) => prevOverlapedTimes.filter((item) => item !== id));
      //   }

      // }
      // Merge overlapedTimes into accordions
      //setAccordions([...localAccordions, ...overlapedTimes]);
      setAccordions(localAccordions);
    }

    setScheduleDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const checkDriverAvailability = async (driverId, date, time) => {
    try {
      if (driverId && time != "Will Call") {
        dispatch(setLoading(true));
        const response = await axios.post(CHECK_DRIVER_AVAILABILITY, {
          driverId,
          date,
          time,
        });
        if (response.data.status === "200") {
          dispatch(setLoading(false));
          //setErrors(null);
          return response.data.status;
        } else {
          dispatch(setLoading(false));
          const validationErrors = {};
          //validationErrors.validError = "ERROR";
          //setErrors(validationErrors);
          return response.data.status;
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("Error checking driver availability:", error);
      return false;
    }
  };

  const handleInputChange = (e) => {
    const { name, value, checked } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: null }));

    // Wait time input validation/formatting
    if (name === "hour" || name === "minute") {
      const maxValue = name === "hour" ? 24 : 59;
      let digits = (value ?? "").toString().replace(/\D/g, "").slice(0, 2);
      if (digits !== "" && Number(digits) > maxValue) {
        digits = String(maxValue);
      }

      setScheduleDetails((prev) => ({
        ...prev,
        [name]: digits,
        frequency: frequency,
        selectedDays: selectedDays,
        pass_id: selectedPassenger.value?.passenger?.passenger_id ?? "",
        payer_id: selectedPassenger?.value?.passenger?.payerDetails?.id ?? "",
      }));
      return;
    }
    // console.log("selectedPassenger",selectedPassenger?.value?.passenger?.payerDetails?.id);
    // console.log("selectedPassenger",scheduleDetails?.payer_id);

    // Handle One Way logic
    if (name === "one_way") {
      if (value === "2") {
        // Yes - One Way
        // Set number of legs to 1 and update accordions
        setNumberOfLeg("1");
        handleAccordianInputChange(accordions.id, "number_of_leg", "1");
      } else {
        // No - Round Trip
        // Set number of legs back to 2 and update accordions
        setNumberOfLeg("2");
        handleAccordianInputChange(accordions.id, "number_of_leg", "2");
      }
    }

    setScheduleDetails((prev) => {
      const next = {
        ...prev,
        [name]: value,
        frequency: frequency,
        selectedDays: selectedDays,
        pass_id: selectedPassenger.value?.passenger?.passenger_id ?? "",
        payer_id: selectedPassenger?.value?.passenger?.payerDetails?.id ?? "",
      };
      if (name === "ma_service_auth_id") {
        const selectedMAItem = activeServiceAuthList.find(
          (item) =>
            String(item?.service_type_id ?? item?.serviceType?.id ?? "") ===
              String(value) || String(item?.id ?? "") === String(value),
        );
        next.service_rate_id =
          selectedMAItem?.nemt_service_rate_id != null &&
          selectedMAItem?.nemt_service_rate_id !== ""
            ? Number(selectedMAItem.nemt_service_rate_id)
            : null;
      }
      if (name === "transport_option") {
        next.service_rate_id =
          value != null && value !== "" ? Number(value) : null;
      }
      return next;
    });
    if (name === "is_wait") {
      setIsWait(value);
      // Reset minutes and seconds when changing the selection
      setMinutes("");
      setSeconds("");
      // Ensure wait time defaults are always valid/visible when toggling.
      setScheduleDetails((prev) => ({
        ...prev,
        hour: "00",
        minute: "00",
      }));
    }

    if (name === "location_type") {
      if (value === "5") {
        setDisabledInput(false);
      } else {
        setDisabledInput(true);
      }
    }
  };

  // Add function to handle frequency change
  const handleFrequencyChange = (newFrequency) => {
    setFrequency(newFrequency);
    setScheduleDetails((prev) => ({
      ...prev,
      frequency: newFrequency,
    }));

    // Reset selected days when frequency changes
    if (newFrequency === "daily") {
      setSelectedDays([]);
      setScheduleDetails((prev) => ({
        ...prev,
        selectedDays: [],
      }));
    }
  };

  // Add function to handle day selection
  const handleDaySelection = (day) => {
    const newSelectedDays = selectedDays.includes(day)
      ? selectedDays.filter((d) => d !== day)
      : [...selectedDays, day];

    setSelectedDays(newSelectedDays);
    setScheduleDetails((prev) => ({
      ...prev,
      selectedDays: newSelectedDays,
    }));
  };

  // Add companion handling functions
  const handleCompanionChange = (value) => {
    setHasCompanions(value);
    if (value === "No") {
      setCompanionCount("");
    }
    setScheduleDetails((prev) => ({
      ...prev,
      has_companions: value,
      companion_count: value === "No" ? "" : companionCount,
    }));
  };

  const handleCompanionCountChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      // Only allow digits
      setCompanionCount(value);
      setScheduleDetails((prev) => ({
        ...prev,
        companion_count: value,
      }));
    }
  };

  // Handlers for Leg 1 specific fields
  const handleLegOneDriverChange = (e) => {
    setLegOneDriver(e.target.value);
  };

  const handleLegOneTripDateChange = (date) => {
    setLegOneTripDate(date);
  };

  const handleLegOneRideIdChange = (e) => {
    setLegOneRideId(e.target.value);
  };

  const handleCalculateLeg1Mileage = async () => {
    const leg1 = accordions.find((acc) => acc.id === 1);
    const pickupId = leg1?.pick_up_loc;
    const dropoffId = leg1?.drop_off_loc;

    if (!pickupId || !dropoffId) {
      Swal.fire({
        title: "Missing Locations",
        text: "Please select both Pick Up Location and Drop off Location for Leg 1.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    if (Number(pickupId) === Number(dropoffId)) {
      Swal.fire({
        title: "Invalid Locations",
        text: "Pickup and Drop-off locations cannot be the same.",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    const pickup = allLocations?.find((loc) => loc.loc_id == pickupId);
    const dropoff = allLocations?.find((loc) => loc.loc_id == dropoffId);

    if (!pickup || !dropoff) {
      Swal.fire({
        title: "Location Not Found",
        text: "Unable to find the selected location details. Please reselect the locations.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      setCalculatingLeg1Mileage(true);
      await loadGoogleMapsScript(GOOGLE_MAPS_API_KEY);

      const pickupCoords = await geocodeAddress(buildLocationAddress(pickup));
      const dropoffCoords = await geocodeAddress(buildLocationAddress(dropoff));

      const distance = calculateHaversineDistance(
        pickupCoords.lat,
        pickupCoords.lng,
        dropoffCoords.lat,
        dropoffCoords.lng,
      );

      const roundedMiles = String(Math.round(distance));
      handleAccordianInputChange(1, "scheduled_miles", roundedMiles);
    } catch (error) {
      console.error("Error calculating mileage:", error);
      Swal.fire({
        title: "Calculation Failed",
        text: "Unable to calculate mileage for the selected locations. Please try again or enter miles manually.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setCalculatingLeg1Mileage(false);
    }
  };

  const search = (event) => {
    // Timeout to emulate a network connection
    setTimeout(() => {
      let _filteredPassengers;

      if (!event.query.trim().length) {
        _filteredPassengers = [...passengers];
      } else {
        const regex = new RegExp(`${event.query}`, "gi");
        _filteredPassengers = passengers
          .filter((user) => {
            return (
              user.first_name?.match(regex) ||
              user.passenger.pass_pmi_no?.match(regex)
            );
          })
          .map((user) => {
            return {
              label:
                `${user.first_name}` +
                " " +
                `${user.middle_name || ""}` +
                " " +
                `${user.last_name || ""} - ${user.passenger.pass_pmi_no || ""}`,
              value: user,
            };
          });
      }
      setFilteredPassenger(_filteredPassengers);
    }, 250);
  };

  const handleResetAddValue = () => {
    setLocationValue({}); // Reset addValue to an empty object
  };

  const handleLocationSelect = async (passengerId) => {
    const response1 = await axios.get(
      GET_LOCATION_URL + `/${passengerId.value?.passenger?.passenger_id ?? ""}`,
    );
    const response2 = await axios.post(GET_DRIVER_URL_V1);
    const locations = response1.data || [];
    setLocation(locations);
    // Also derive pickup/dropoff arrays and allLocations so selects refresh immediately
    try {
      const _pickupLocation = locations.filter(
        (option) => option.loc_type === 1,
      );
      const _dropOffLocation = locations.filter(
        (option) => option.loc_type === 2,
      );
      setPickUplocation(_pickupLocation);
      setDropOffLocation(_dropOffLocation);
      setAllLocations(locations);
    } catch (e) {
      // no-op
    }
    setAssignedDriver(response2.data?.result);
  };

  const fetchNemtTransportOptions = async (payerId) => {
    try {
      if (!payerId) {
        setTransportOptions([]);
        setLoadingTransportOptions(false);
        return;
      }

      setLoadingTransportOptions(true);
      const response = await axios.get(GET_NEMT_SERVICES_V1, {
        params: { payer: payerId },
      });
      const isOk =
        response?.data?.success === true ||
        response?.data?.status === 200 ||
        response?.data?.status === "200";

      if (isOk && Array.isArray(response?.data?.data)) {
        setTransportOptions(
          response.data.data.map((item) => ({
            id: item?.id,
            service_name: item?.serviceDetails?.service_name ?? "",
          })),
        );
      } else {
        setTransportOptions([]);
      }
    } catch (error) {
      console.error("Error fetching NEMT transport options:", error);
      setTransportOptions([]);
    } finally {
      setLoadingTransportOptions(false);
    }
  };

  useEffect(() => {
    const loadUser = async () => {
      const response = await axios.get(GET_SCHEPASSENGER_LIST);
      setPassengers(response.data);
    };
    loadUser();
  }, []);

  useEffect(() => {
    if (selectedPassenger.value?.passenger?.passenger_id) {
      const loadLocation = async () => {
        const response1 = await axios.get(
          GET_LOCATION_URL +
            `/${selectedPassenger.value?.passenger?.passenger_id ?? ""}`,
        );
        //setLocation(response1.data);
        const locations = response1.data;
        //const _pickupLocation = locations.filter((option) => option.loc_type === 1);
        //const _dropOffLocation = locations.filter((option) => option.loc_type === 2);
        const _pickupLocation = locations.filter(
          (option) => option.loc_type === 1,
        );
        const _dropOffLocation = locations.filter(
          (option) => option.loc_type === 2,
        );
        if (_pickupLocation[0]?.locationType?.location_type_name === null) {
          setPickupLocationType(true);
        }
        if (_dropOffLocation[0]?.locationType?.location_type_name === null) {
          setDropoffLocationType(true);
        }
        setPickUplocation(_pickupLocation);
        setDropOffLocation(_dropOffLocation);
        setAllLocations(locations);
      };
      loadLocation();
    }
  }, [selectedPassenger, locationValue, setValue]);

  // Function to get location type from allLocations
  const getLocationTypeFromAllLocations = (locationId) => {
    if (!locationId || !allLocations) return "";

    const location = allLocations.find((loc) => loc.loc_id == locationId);
    return location?.locationType
      ? location.locationType.location_type_name
      : "";
  };

  // Function to update location types for accordions
  const updateLocationTypes = (accordionId, field, locationId) => {
    const locationType = getLocationTypeFromAllLocations(locationId);
    setLocationTypes((prev) => ({
      ...prev,
      [`${accordionId}_${field}`]: locationType,
    }));
    // Clear stale validation once location type is fixed via location update flow.
    if (locationType && String(locationType).trim() !== "") {
      const fieldKey = field === "pickup" ? "pick_up_loc" : "drop_off_loc";
      setErrors((prevErrors) => {
        if (!prevErrors || !prevErrors[accordionId]) return prevErrors;
        if (!prevErrors[accordionId]?.[fieldKey]) return prevErrors;
        const nextLegErrors = { ...prevErrors[accordionId] };
        delete nextLegErrors[fieldKey];
        return {
          ...prevErrors,
          [accordionId]: nextLegErrors,
        };
      });
    }
  };

  useEffect(() => {
    const handleInputChangeWrapper = (event) => {
      handleInputChange(event);
    };
    handleInputChangeWrapper({ target: { value: selectedValue } });
  }, [selectedValue, pickUpLocation, dropOffLocation, dropOffTime, pickUpTime]);

  // Update location types when accordions change and allLocations is available
  useEffect(() => {
    if (allLocations && allLocations.length > 0) {
      accordions.forEach((accordion) => {
        if (accordion.pick_up_loc) {
          updateLocationTypes(accordion.id, "pickup", accordion.pick_up_loc);
        }
        if (accordion.drop_off_loc) {
          updateLocationTypes(accordion.id, "dropoff", accordion.drop_off_loc);
        }
      });
    }
  }, [accordions, allLocations]);

  useEffect(() => {
    const numberOfLegs = parseInt(scheduleDetails?.number_of_leg || 2);

    if (pickUpLocation?.length > 0 || dropOffLocation?.length > 0) {
      // Check if this is initial load or passenger change
      const isInitialLoad =
        accordions.length === 0 ||
        accordions.every((acc) => !acc.pick_up_loc && !acc.drop_off_loc);

      // Also check if this is a passenger change by comparing current accordion locations with new location data
      const isPassengerChange =
        accordions.length > 0 &&
        accordions.some((acc) => {
          if (acc.pick_up_loc) {
            // Check if the current location is not in the new pickup locations
            return !pickUpLocation.some((loc) => loc.loc_id == acc.pick_up_loc);
          }
          return false;
        });

      if (isInitialLoad || isPassengerChange) {
        const updatedAccordions = [];

        for (let i = 0; i < numberOfLegs; i++) {
          if (i === 0) {
            // First leg - use pickup and dropoff from location arrays
            updatedAccordions.push({
              ...accordions[i],
              id: i + 1,
              expanded: true,
              pick_up_loc: pickUpLocation[0]?.loc_id || "",
              drop_off_loc: dropOffLocation[0]?.loc_id || "",
              number_of_leg: String(numberOfLegs),
              pickup_latitude: "",
              pickup_longitude: "",
              dropoff_latitude: "",
              dropoff_longitude: "",
            });
          } else {
            // Other legs - special logic for leg 2 to create round trip
            let pickupLoc = "";
            let dropoffLoc = "";

            if (i === 1) {
              // Leg 2: pickup from leg 1's dropoff, dropoff to leg 1's pickup (round trip)
              pickupLoc = dropOffLocation[0]?.loc_id || "";
              dropoffLoc = pickUpLocation[0]?.loc_id || "";
            } else {
              // Leg 3+: pickup from previous leg's dropoff
              pickupLoc = dropOffLocation[0]?.loc_id || "";
              dropoffLoc = "";
            }

            updatedAccordions.push({
              ...accordions[i],
              id: i + 1,
              expanded: i === 1,
              pick_up_loc: pickupLoc,
              drop_off_loc: dropoffLoc,
              number_of_leg: String(numberOfLegs),
              pickup_latitude: "",
              pickup_longitude: "",
              dropoff_latitude: "",
              dropoff_longitude: "",
            });
          }
        }

        setAccordions(updatedAccordions);
      }
    }

    // console.log("accordions",accordions);
  }, [pickUpLocation, dropOffLocation, selectedPassenger]);

  // Add useEffect to sync frequency and selectedDays with scheduleDetails
  useEffect(() => {
    setScheduleDetails((prev) => ({
      ...prev,
      frequency: frequency,
      selectedDays: selectedDays,
    }));
  }, [frequency, selectedDays]);

  // Debug useEffect to log scheduleDetails changes
  useEffect(() => {
    // Removed console.log
  }, [scheduleDetails]);

  // Debug useEffect to log errors changes
  useEffect(() => {
    // Removed console.log
  }, [errors]);

  const isMAPayer =
    selectedPassenger?.value?.passenger?.payerDetails?.payer_name === "MA";

  // Fetch NEMT transport options when non-MA payer is selected
  useEffect(() => {
    if (isMAPayer) {
      setTransportOptions([]);
      setLoadingTransportOptions(false);
      return;
    }
    const payerId = selectedPassenger?.value?.passenger?.payerDetails?.id;
    if (!payerId) {
      setTransportOptions([]);
      return;
    }
    fetchNemtTransportOptions(payerId);
  }, [isMAPayer, selectedPassenger?.value?.passenger?.payerDetails?.id]);

  // Fetch active service auth list when payer is MA
  useEffect(() => {
    if (!isMAPayer) {
      setActiveServiceAuthList([]);
      setScheduleDetails((prev) => ({
        ...prev,
        ma_service_auth_id: "",
        service_rate_id: null,
      }));
      setLoadingActiveServiceAuth(false);
      setMaServiceAuthError("");
      return;
    }
    const passengerId = selectedPassenger?.value?.passenger?.passenger_id;
    if (!passengerId) {
      setActiveServiceAuthList([]);
      setLoadingActiveServiceAuth(false);
      setMaServiceAuthError("");
      return;
    }
    let cancelled = false;
    setLoadingActiveServiceAuth(true);
    setMaServiceAuthError("");
    axios
      .get(`${GET_SERVICE_AUTH_ACTIVE}/${passengerId}`)
      .then((response) => {
        if (cancelled) return;
        if (
          (response?.data?.status === "200" ||
            response?.data?.status === 200) &&
          Array.isArray(response?.data?.data)
        ) {
          const items = response.data.data;
          setActiveServiceAuthList(items);
          setMaServiceAuthError(
            items.length === 0
              ? "Plase add Service Authorization for selected Passenger"
              : "",
          );
        } else {
          setActiveServiceAuthList([]);
          setMaServiceAuthError(
            "Plase add Service Authorization for selected Passenger",
          );
        }
      })
      .catch(() => {
        if (!cancelled) {
          setActiveServiceAuthList([]);
          setMaServiceAuthError("");
        }
      })
      .finally(() => {
        if (!cancelled) setLoadingActiveServiceAuth(false);
      });
    return () => {
      cancelled = true;
    };
  }, [isMAPayer, selectedPassenger?.value?.passenger?.passenger_id]);

  const handlePassengerChange = (passenger) => {
    setSelectedPassenger(passenger);
    setMaServiceAuthError("");
    setPickupAddress("");
    setDropoffAddress("");
    setTotalDistance("");
    const passId = passenger?.value?.passenger?.passenger_id ?? "";
    const payerId = passenger?.value?.passenger?.payerDetails?.id ?? "";
    setScheduleDetails((prev) => ({
      ...prev,
      pass_id: passId,
      payer_id: payerId,
      ma_service_auth_id: "",
      transport_option: "",
      service_rate_id: null,
    }));
  };

  async function handleFormSubmit(e) {
    //console.log("scheduleDetails",scheduleDetails);
    //return false;
    e.preventDefault();
    //alert("hai");
    //console.log( overlapedTimes );
    const allErrors = {};
    const accordionsWithError = [];
    setOverlapedTimes([]);
    // if (overlapedTimes.length > 0) {
    //   Swal.fire({
    //     title: 'Failed!',
    //     text: "A schedule already exists for the selected driver in the chosen time slot. Please update the existing schedule before assigning a new one.",
    //     icon: 'warning',
    //     confirmButtonText: 'OK',
    //     allowOutsideClick: false
    //   }).then(() => {
    //     // Reset overlapedTimes after showing the error message
    //     setOverlapedTimes([]);
    //   });
    //   return false; // Exit the function if there are errors

    // }
    if (Object.keys(locationErrors).length > 0) {
      Swal.fire({
        title: "Failed",
        text: "Please ensure pickup and drop-off locations are not the same.",
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }
    if (isMAPayer && activeServiceAuthList.length === 0) {
      setMaServiceAuthError(
        "Plase add Service Authorization for selected Passenger",
      );
      return false;
    }

    // Create a complete schedule details object with current state
    // Ensure payer_id is set from selectedPassenger if missing in scheduleDetails (e.g. passenger selected but no other field changed)
    const effectivePayerId = scheduleDetails.payer_id ?? "";
    const effectivePassId =
      (scheduleDetails.pass_id ||
        selectedPassenger?.value?.passenger?.passenger_id) ??
      "";
    const completeScheduleDetails = {
      ...scheduleDetails,
      pass_id: effectivePassId,
      payer_id: effectivePayerId,
      frequency: frequency,
      selectedDays: selectedDays,
    };
    // Check if we're in range mode and have weekly/biweekly frequency
    if (
      completeScheduleDetails.date_mode === "range" &&
      (completeScheduleDetails.frequency === "weekly" ||
        completeScheduleDetails.frequency === "biweekly")
    ) {
      // Removed console.log
    }

    const detailsToValidate = completeScheduleDetails;
    const isValid = scheduleFormValidation(detailsToValidate, { isMAPayer });
    accordions.forEach((accordion) => {
      const errors = validateAccordion(
        accordion,
        scheduleDetails.schedule_date,
        scheduleDetails.date_mode,
        scheduleDetails.start_date,
        scheduleDetails.end_date,
        {
          isMAPayer,
          validateScheduledMilesPerLeg: true,
          skipRideIdValidation: !isMAPayer,
          allLocations,
        },
      );
      if (Object.keys(errors).length > 0) {
        allErrors[accordion.id] = errors; // Store errors by accordion ID
        accordionsWithError.push(accordion.id);
      }
    });
    // Validate leg times
    const legValidationErrors = validateLegs(accordions);
    if (Object.keys(legValidationErrors).length > 0) {
      Object.keys(legValidationErrors).forEach((key) => {
        //alert(parseInt(key.match(/\d+/)[0], 10) );
        const legIndex = parseInt(key.match(/\d+/)[0], 10) - 1;
        if (!allErrors[accordions[legIndex].id]) {
          allErrors[accordions[legIndex].id] = {};
        }
        const errorKey = key.replace(/_\d+$/, "");
        allErrors[accordions[legIndex].id][errorKey] = legValidationErrors[key];
        if (!accordionsWithError.includes(accordions[legIndex].id)) {
          accordionsWithError.push(accordions[legIndex].id);
        }
      });
    }
    const combinedErrors = { ...isValid, ...allErrors };
    if (Object.keys(combinedErrors).length > 0) {
      setErrors(combinedErrors); // Keep top-level and per-leg validation messages together
      setAccordionsWithError(accordionsWithError);
      return; // Exit the function if there are errors
    }
    if (Object.keys(isValid).length === 0) {
      try {
        dispatch(setLoading(true));
        setIsAddingSchedule(true);
        // Driver is now assigned per-leg (on accordions), not on scheduleDetails
        const { assigned_driver: _assignedDriver, ...scheduleDetailsBase } =
          completeScheduleDetails;
        const scheduleDetailsForPayload = isMAPayer
          ? (() => {
              const { ma_service_auth_id, ...rest } = scheduleDetailsBase;
              const selectedMAItem = activeServiceAuthList.find(
                (i) =>
                  String(i?.service_type_id ?? i?.serviceType?.id ?? "") ===
                    String(ma_service_auth_id) ||
                  String(i?.id ?? "") === String(ma_service_auth_id),
              );
              const serviceRateId =
                selectedMAItem?.nemt_service_rate_id != null &&
                selectedMAItem?.nemt_service_rate_id !== ""
                  ? Number(selectedMAItem.nemt_service_rate_id)
                  : completeScheduleDetails.service_rate_id != null
                    ? Number(completeScheduleDetails.service_rate_id)
                    : null;
              return {
                ...rest,
                transport_type: 2,
                transport_option: ma_service_auth_id || "",
                sa_number: selectedMAItem?.sa_number ?? null,
                diagnosis_code: selectedMAItem?.diagnosis_code ?? null,
                service_rate_id: serviceRateId,
                appt_time: completeScheduleDetails.appt_time || "12:00 AM",
              };
            })()
          : (() => {
              const { ma_service_auth_id, ...rest } = scheduleDetailsBase;
              const serviceRateId =
                rest.transport_option != null && rest.transport_option !== ""
                  ? Number(rest.transport_option)
                  : completeScheduleDetails.service_rate_id != null
                    ? Number(completeScheduleDetails.service_rate_id)
                    : null;
              return {
                ...rest,
                transport_type: 2,
                service_rate_id: serviceRateId,
              };
            })();
        const generateSixDigitRideId = () =>
          String(Math.floor(100000 + Math.random() * 900000));
        const generatePrefixedRideId = () =>
          `T${Math.floor(100000 + Math.random() * 900000)}`;
        const usedRideIds = new Set(
          accordions
            .map((acc) => String(acc?.ride_id ?? "").trim())
            .filter((rideId) => rideId.length > 0),
        );
        const getUniqueRideId = (prefixWithT = false) => {
          let rideId = "";
          do {
            rideId = prefixWithT
              ? generatePrefixedRideId()
              : generateSixDigitRideId();
          } while (usedRideIds.has(rideId));
          usedRideIds.add(rideId);
          return rideId;
        };
        const accordionsForPayload = isMAPayer
          ? accordions.map((acc) => ({
              ...acc,
              ride_id: getUniqueRideId(false),
              distance: Number(acc.scheduled_miles) || 0,
            }))
          : accordions.map((acc) => ({
              ...acc,
              ride_id:
                String(acc?.ride_id ?? "").trim() || getUniqueRideId(true),
              distance: Number(acc.scheduled_miles) || 0,
            }));
        const payload = {
          scheduleDetails: scheduleDetailsForPayload,
          accordions: accordionsForPayload,
        };
        // Use new v1 endpoint for Add Schedule (keep ADD_SCHEDULE_URL for older flows)
        const response = await axios.post(ADD_SCHEDULE_V1_URL, payload);

        //console.log(response.data.status);
        if (response.data.status === "200") {
          navigate("/home/schedule/list/v1", { replace: true });
          Swal.fire({
            title: "Success!",
            text: response.data.message,
            icon: "success",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            title: "Failed!",
            text: response.data.message,
            icon: "Error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
          //console.log(response.data.message);
        }
      } catch (error) {
        if (error.response && error.response.data) {
          console.error("Backend Error:", error.response.data);

          Swal.fire({
            title: "Error!",
            text:
              error.response.data.message || "Server responded with an error.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          console.error("Unexpected Error:", error);
          Swal.fire({
            title: "Error!",
            text: "Unexpected error occurred. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        }
      } finally {
        dispatch(setLoading(false));
        setIsAddingSchedule(false);
      }
    } else {
      // Removed console.log
    }
  }

  const formatAddress = (source = {}) => {
    const root = source && typeof source === "object" ? source : {};
    const nested =
      root.passenger && typeof root.passenger === "object"
        ? root.passenger
        : {};

    const clean = (s) =>
      typeof s === "string"
        ? s
            .trim()
            .replace(/\s+/g, " ")
            .replace(/,+$/, "")
            .replace(/^[, ]+|[, ]+$/g, "")
        : "";

    const pick = (...values) => {
      for (const v of values) {
        if (typeof v === "string" && v.trim().length > 0) return clean(v);
      }
      return "";
    };

    const stateName = pick(
      root.state_master_lists?.state_name,
      root.state_master_list?.state_name,
      root.state_list?.state_name,
      root.state?.state_name,
      typeof root.state === "string" ? root.state : undefined,
      nested.state_master_lists?.state_name,
      nested.state_master_list?.state_name,
      nested.state_list?.state_name,
      nested.state?.state_name,
      typeof nested.state === "string" ? nested.state : undefined,
    );

    const addr1 = pick(
      root.address1,
      root.address_1,
      root.address,
      root.pass_addr1,
      nested.address1,
      nested.address_1,
      nested.address,
      nested.pass_addr1,
    );
    const addr2 = pick(
      root.address2,
      root.address_2,
      root.pass_addr2,
      nested.address2,
      nested.address_2,
      nested.pass_addr2,
    );
    const city = pick(root.city, nested.city);
    const zip = pick(root.zip, nested.zip);

    // If all are empty
    if (!addr1 && !addr2 && !city && !stateName && !zip) return "";

    // ✅ Check if address1 already includes city/state/zip (full address)
    const hasFullAddress =
      (city && addr1.toLowerCase().includes(city.toLowerCase())) ||
      (stateName && addr1.toLowerCase().includes(stateName.toLowerCase())) ||
      (zip && addr1.toLowerCase().includes(zip));

    if (hasFullAddress) return addr1;

    // ✅ Skip address2 if same or contained within address1
    const finalAddr2 =
      addr2 &&
      addr2.toLowerCase() !== addr1.toLowerCase() &&
      !addr1.toLowerCase().includes(addr2.toLowerCase())
        ? addr2
        : null;

    // ✅ Build final formatted string
    return [addr1, finalAddr2, city, stateName, zip].filter(Boolean).join(", ");
  };

  return (
    <>
      <div
        className="tab-pane fade active show "
        id="create-schedule"
        role="tabpanel"
        aria-labelledby="profile-tab"
      >
        <section>
          <div className="d-flex justify-content-between form-container">
            <div>
              <h2 className="fs-5 font-weight-600">Add Schedule </h2>
            </div>
            <div>
              <span>{currentDateFormat(currentDate)}</span>
            </div>
          </div>
        </section>
        <div className="container-fluid px-mobile-2 bg-white px-5 py-4">
          <section>
            <form action="#">
              {/* First Row */}
              <div className="row mb-3">
                <div className="col-3">
                  <div className="search-client">
                    <label className="require-field">Search Passenger </label>
                    <AutoComplete
                      field="label"
                      value={selectedPassenger}
                      suggestions={filteredPassenger}
                      completeMethod={search}
                      onChange={(e) => setSelectedPassenger(e.value)}
                      onSelect={(e) => handleLocationSelect(e.value)}
                      className="search-box-autocomplete"
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="form-item">
                    <label>Passenger Name</label>
                    <input
                      type="text"
                      readOnly={true}
                      className="form-control"
                      value={
                        selectedPassenger?.value &&
                        (selectedPassenger.value.first_name ||
                          selectedPassenger.value.middle_name ||
                          selectedPassenger.value.last_name)
                          ? (selectedPassenger.value.first_name || "") +
                            " " +
                            (selectedPassenger.value.middle_name || "") +
                            " " +
                            (selectedPassenger.value.last_name || "")
                          : ""
                      }
                      id="client_name"
                      name="client_name"
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div className="date-selector">
                    <label>Date of Birth</label>
                    <div className="input-group">
                      <input
                        type="text"
                        readOnly={true}
                        className="form-control datepicker hasDatepicker"
                        id="client-dob"
                        name="client_date_of_birth"
                        value={
                          dateFormat(selectedPassenger.value?.user_dob) ?? ""
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Payor</label>
                    <input
                      type="text"
                      readOnly={true}
                      className="form-control"
                      id="payer"
                      name="payer"
                      value={
                        selectedPassenger.value?.passenger?.payerDetails
                          ?.payer_name ?? ""
                      }
                    />
                  </div>
                </div>
              </div>

              {/* Second Row */}
              <div className="row mb-3">
                <div className="col-6">
                  <div>
                    <label>Address</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly={true}
                      id="address"
                      name="address"
                      value={formatAddress(selectedPassenger.value)}
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Member ID/Insurance Number</label>
                    <input
                      type="text"
                      readOnly={true}
                      className="form-control"
                      id="insurance_number"
                      name="insurance_number"
                      value={
                        selectedPassenger.value?.passenger?.pass_pmi_no ?? ""
                      }
                    />
                  </div>
                </div>
                <div className="col-3">
                  <div>
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      readOnly={true}
                      id="phone_number"
                      name="phone-number"
                      value={
                        selectedPassenger.value?.passenger?.pass_home_phn_no ??
                        ""
                      }
                    />
                  </div>
                </div>
              </div>
            </form>
          </section>
          <section>
            <div>
              <p className="sub-title">Add Schedule</p>
            </div>

            <div className="add-new-trip">
              <form onSubmit={handleFormSubmit}>
                <div className="mb-2">
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateMode"
                      id="singleDate"
                      value="single"
                      checked={scheduleDetails.date_mode === "single"}
                      onChange={() => {
                        setScheduleDetails((prev) => ({
                          ...prev,
                          date_mode: "single",
                        }));
                        // Reset frequency and selectedDays when switching to single mode
                        setFrequency("daily");
                        setSelectedDays([]);
                      }}
                    />
                    <label className="form-check-label" htmlFor="singleDate">
                      Single Date
                    </label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="dateMode"
                      id="multipleDates"
                      value="range"
                      checked={scheduleDetails.date_mode === "range"}
                      onChange={() => {
                        setScheduleDetails((prev) => ({
                          ...prev,
                          date_mode: "range",
                        }));
                        // Reset frequency and selectedDays when switching to range mode
                        setFrequency("daily");
                        setSelectedDays([]);
                      }}
                    />
                    <label className="form-check-label" htmlFor="multipleDates">
                      Multiple Days
                    </label>
                  </div>
                </div>

                {/* Frequency selector for multiple days */}
                {(() => {
                  const shouldShowFrequency =
                    scheduleDetails.date_mode === "range";

                  return shouldShowFrequency ? (
                    <div className="mb-3 frequency-selector">
                      <label className="form-label">Frequency</label>
                      <div className="frequency-options-box">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="daily"
                            value="daily"
                            checked={frequency === "daily"}
                            onChange={() => handleFrequencyChange("daily")}
                          />
                          <label className="form-check-label" htmlFor="daily">
                            Daily
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="weekly"
                            value="weekly"
                            checked={frequency === "weekly"}
                            onChange={() => handleFrequencyChange("weekly")}
                          />
                          <label className="form-check-label" htmlFor="weekly">
                            Weekly
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="frequency"
                            id="biweekly"
                            value="biweekly"
                            checked={frequency === "biweekly"}
                            onChange={() => handleFrequencyChange("biweekly")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="biweekly"
                          >
                            Bi-weekly
                          </label>
                        </div>
                      </div>
                      {errors.frequency && (
                        <span className="errors">{errors.frequency}</span>
                      )}
                    </div>
                  ) : null;
                })()}

                {/* Day selection for weekly and biweekly */}
                {(() => {
                  const shouldShowDaySelection =
                    scheduleDetails.date_mode === "range" &&
                    (frequency === "weekly" || frequency === "biweekly");

                  return shouldShowDaySelection ? (
                    <div className="mb-3 day-selection">
                      <label className="form-label">Select Days</label>
                      <div className="d-flex gap-3">
                        {[
                          "Sunday",
                          "Monday",
                          "Tuesday",
                          "Wednesday",
                          "Thursday",
                          "Friday",
                          "Saturday",
                        ].map((day, index) => (
                          <div key={index} className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`day-${index}`}
                              checked={selectedDays.includes(index)}
                              onChange={() => handleDaySelection(index)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`day-${index}`}
                            >
                              {day.substring(0, 3)}
                            </label>
                          </div>
                        ))}
                      </div>
                      {errors.selectedDays && (
                        <span className="errors">{errors.selectedDays}</span>
                      )}
                      {/* Debug info */}
                      {/* <div style={{fontSize: '12px', color: '#666', marginTop: '5px'}}>
                        Debug: date_mode={scheduleDetails.date_mode}, frequency={frequency}, selectedDays={JSON.stringify(selectedDays)}
                      </div> */}
                    </div>
                  ) : null;
                })()}
                <div className="schedule-form-1">
                  <div className="row">
                    <div className="col-3 date-selector align-top">
                      {scheduleDetails.date_mode === "range" ? (
                        <div className="d-flex gap-2 multi-form align-items-end">
                          <div className="col-6 p-0">
                            <div>
                              <label className="require-field">Trip Date</label>
                              <DatePicker
                                selected={startDate}
                                dateFormat="MM/dd/yyyy"
                                selectsStart
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(date) => {
                                  setStartDate(date);
                                  handleInputChange({
                                    target: {
                                      name: "start_date",
                                      value: date
                                        ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
                                        : "",
                                    },
                                  });
                                }}
                                className="form-control"
                                placeholderText="Start Date"
                              />
                            </div>
                            {/* { errors.start_date && <span className="errors">{errors.start_date}</span>} */}
                            <div
                              className="error-placeholder"
                              style={{ minHeight: "18px" }}
                            >
                              {errors.start_date ? (
                                <span className="errors">
                                  {errors.start_date}
                                </span>
                              ) : (
                                <span className="errors">&nbsp;</span>
                              )}
                            </div>
                          </div>
                          <div className="col-6 p-0">
                            <div>
                              <label> &nbsp; </label>
                              <DatePicker
                                selected={endDate}
                                dateFormat="MM/dd/yyyy"
                                selectsEnd
                                startDate={startDate}
                                endDate={endDate}
                                onChange={(date) => {
                                  setEndDate(date);
                                  handleInputChange({
                                    target: {
                                      name: "end_date",
                                      value: date
                                        ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
                                        : "",
                                    },
                                  });
                                }}
                                className="form-control"
                                placeholderText="End Date"
                                minDate={startDate || currentDate}
                              />
                            </div>
                            {/* {errors.end_date && <span className="errors">{errors.end_date}</span>} */}
                            <div
                              className="error-placeholder"
                              style={{ minHeight: "18px" }}
                            >
                              {/* <span class="errors">{errors.end_date && <span className="errors">{errors.end_date}</span>}</span> */}
                              {errors.end_date ? (
                                <span className="errors">
                                  {errors.end_date}
                                </span>
                              ) : (
                                <span className="errors">&nbsp;</span>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="d-flex gap-1">
                      <div className="col-1">
                        <label>One Way</label>
                        <div className="d-flex gap-1 align-items-center mt-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="one_way"
                              id="one_way_yes"
                              value="2"
                              checked={scheduleDetails.one_way === "2"}
                              onChange={handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="one_way_yes"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="one_way"
                              id="one_way_no"
                              value="1"
                              checked={scheduleDetails.one_way === "1"}
                              onChange={handleInputChange}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="one_way_no"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>

                      {scheduleDetails.one_way === "2" && (
                        <div className="col-2">
                          <div>
                            <label>&nbsp;</label>
                            <input
                              type="text"
                              className="form-control"
                              id="leg_one_text"
                              name="leg_one_text"
                              placeholder="No Load"
                              autoComplete="off"
                              onKeyDown={restrictSpecialCharacters}
                              onChange={handleInputChange}
                            />
                            {errors.leg_one_text && (
                              <span className="errors">
                                {errors.leg_one_text}
                              </span>
                            )}
                          </div>
                        </div>
                      )}

                      {scheduleDetails.one_way !== "2" && (
                        <div className="col-1">
                          <label className="require-field">No of Legs</label>
                          <div>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              value={numberOfLeg}
                              onChange={(e) =>
                                handleAccordianInputChange(
                                  accordions.id,
                                  "number_of_leg",
                                  e.target.value,
                                )
                              }
                              name="number_of_leg"
                            >
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                            </select>
                            {errors.number_of_leg && (
                              <span className="errors">
                                {errors.number_of_leg}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-2" style={{ display: "none" }}>
                      <label className="require-field">Bill Amount</label>
                      <div>
                        <input
                          type="text"
                          className="form-control"
                          id="bill_amount"
                          name="bill_amount"
                          autoComplete="off"
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              // Valid input (empty or only digits)
                              handleInputChange(e); // Call your original handler
                            } else {
                              // Invalid input — block by resetting the value
                              e.target.value = e.target.value.replace(
                                /\D/g,
                                "",
                              ); // Remove non-digits
                            }
                          }}
                        />
                        {errors.bill_amount && (
                          <span className="errors">{errors.bill_amount}</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <section>
                  {/* Render Accordions dynamically */}
                  {accordions
                    .filter((accordion) => {
                      // If "One Way" is "Yes", only show Leg 1
                      if (scheduleDetails.one_way === "2") {
                        return accordion.id === 1;
                      }
                      // Otherwise show all accordions
                      return true;
                    })
                    .map((accordion) => (
                      <Accordion
                        style={{ background: "#80808012" }}
                        key={accordion.id}
                        expanded={
                          accordion.expanded ||
                          accordionsWithError.includes(accordion.id)
                        }
                        onChange={() => handleToggle(accordion.id)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${accordion.id}-content`}
                          id={`panel${accordion.id}-header`}
                        >
                          <Typography
                            style={{
                              marginTop: "10px",
                              fontWeight: "bold",
                              textDecoration: "underline",
                            }}
                          >
                            Leg {accordion.id}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div>
                            {/* Leg 1 specific fields */}
                            {accordion.id === 1 && (
                              <>
                                <div className="row mb-3">
                                  <div className="col-2">
                                    <label>Assign Driver</label>
                                    <select
                                      className="form-select"
                                      value={accordion.assigned_driver ?? ""}
                                      onChange={(e) =>
                                        handleAccordianInputChange(
                                          accordion.id,
                                          "assigned_driver",
                                          e.target.value,
                                        )
                                      }
                                    >
                                      <option value="">Select Driver</option>
                                      {assignedDriver.map((driver, index) => (
                                        <option
                                          key={index}
                                          value={driver.driver_id}
                                        >
                                          {driver.driver_name
                                            ? driver.driver_name
                                            : driver.full_name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                  {scheduleDetails.date_mode === "single" && (
                                    <div className="col-2 date-selector align-top">
                                      <label className="require-field">
                                        Trip Date
                                      </label>
                                      <div className="d-flex date-picker-wrapper schedule-date align-items-end">
                                        <DatePicker
                                          selected={scheduleDate}
                                          dateFormat="MM/dd/yyyy"
                                          autoComplete="off"
                                          className="datepicker form-control hasDatepicker"
                                          id="schedule_date"
                                          name="schedule_date"
                                          onChange={(date) => {
                                            setScheduleDate(date);
                                            handleInputChange({
                                              target: {
                                                name: "schedule_date",
                                                value: date
                                                  ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
                                                  : "",
                                              },
                                            });
                                          }}
                                          ref={datepickerRef}
                                        />
                                        <button
                                          className="btn datepicker-button width-50"
                                          type="button"
                                          onClick={() =>
                                            datepickerRef.current.setOpen(true)
                                          }
                                        >
                                          <img
                                            src={calender}
                                            className="img-fluid"
                                            width="20"
                                            height="20"
                                            alt="calender"
                                          />
                                        </button>
                                      </div>
                                      {errors.schedule_date && (
                                        <span className="errors">
                                          {errors.schedule_date}
                                        </span>
                                      )}
                                    </div>
                                  )}

                                  {isMAPayer ? (
                                    <>
                                      <div className="col-2">
                                        <label className="require-field">
                                          {isMAPayer
                                            ? "Service Type"
                                            : "Transport Options"}{" "}
                                        </label>
                                        <select
                                          className="form-select"
                                          value={
                                            scheduleDetails.ma_service_auth_id ||
                                            ""
                                          }
                                          name="ma_service_auth_id"
                                          onChange={handleInputChange}
                                          disabled={
                                            loadingActiveServiceAuth ||
                                            activeServiceAuthList.length === 0
                                          }
                                        >
                                          <option value="">
                                            {loadingActiveServiceAuth
                                              ? "Loading..."
                                              : "Select Service"}
                                          </option>
                                          {activeServiceAuthList.map((item) => (
                                            <option
                                              key={item?.id}
                                              value={
                                                item?.service_type_id ??
                                                item?.serviceType?.id ??
                                                ""
                                              }
                                            >
                                              {item?.serviceType
                                                ?.service_name ?? "—"}
                                            </option>
                                          ))}
                                        </select>
                                        {maServiceAuthError && (
                                          <small className="text-danger">
                                            {maServiceAuthError}
                                          </small>
                                        )}
                                        {errors.ma_service_auth_id && (
                                          <span className="errors">
                                            {errors.ma_service_auth_id}
                                          </span>
                                        )}
                                      </div>
                                      <div className="col-2">
                                        <label className="require-field">
                                          Scheduled Miles
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="scheduled_miles_leg_1"
                                          value={
                                            accordion.scheduled_miles ?? ""
                                          }
                                          onChange={(e) =>
                                            handleAccordianInputChange(
                                              accordion.id,
                                              "scheduled_miles",
                                              e.target.value,
                                            )
                                          }
                                          placeholder="Enter miles"
                                          inputMode="decimal"
                                        />
                                        {errors[accordion.id]
                                          ?.scheduled_miles && (
                                          <span className="errors">
                                            {
                                              errors[accordion.id]
                                                .scheduled_miles
                                            }
                                          </span>
                                        )}
                                        <button
                                          className="btn btn-primary rounded-1 btn-sm mt-2"
                                          type="button"
                                          style={{
                                            background: "#31876f",
                                            border: "unset",
                                            height: "38px",
                                            color: "#fff",
                                            padding: "7px",
                                          }}
                                          onClick={handleCalculateLeg1Mileage}
                                          disabled={
                                            calculatingLeg1Mileage ||
                                            !accordion.pick_up_loc ||
                                            !accordion.drop_off_loc
                                          }
                                        >
                                          {calculatingLeg1Mileage
                                            ? "Calculating..."
                                            : "Calculate Mileage"}
                                        </button>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <div className="col-2">
                                        <label className="require-field">
                                          Transport Options
                                        </label>
                                        <select
                                          className="form-select"
                                          value={
                                            scheduleDetails.transport_option
                                          }
                                          onChange={handleInputChange}
                                          name="transport_option"
                                          disabled={
                                            !selectedPassenger?.value?.passenger
                                              ?.payerDetails?.id ||
                                            loadingTransportOptions
                                          }
                                        >
                                          <option value="">
                                            {loadingTransportOptions
                                              ? "Loading services..."
                                              : "Select Transport Option"}
                                          </option>
                                          {transportOptions.map((option) => (
                                            <option
                                              key={option.id}
                                              value={option.id}
                                            >
                                              {option.service_name}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.transport_option && (
                                          <span className="errors">
                                            {errors.transport_option}
                                          </span>
                                        )}
                                      </div>

                                      <div className="col-2">
                                        <label>Ride ID / Conf#</label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          autoComplete="off"
                                          name={`ride_id_leg_${accordion.id}`}
                                          value={accordion.ride_id || ""}
                                          onChange={(e) =>
                                            handleAccordianInputChange(
                                              accordion.id,
                                              "ride_id",
                                              e.target.value,
                                            )
                                          }
                                          placeholder="Enter Ride ID"
                                        />
                                        {errors[accordion.id]?.ride_id && (
                                          <span className="errors">
                                            {errors[accordion.id].ride_id}
                                          </span>
                                        )}
                                      </div>

                                      <div className="col-2">
                                        <label className="require-field">
                                          Scheduled Miles
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          name="scheduled_miles_leg_1"
                                          value={
                                            accordion.scheduled_miles ?? ""
                                          }
                                          onChange={(e) =>
                                            handleAccordianInputChange(
                                              accordion.id,
                                              "scheduled_miles",
                                              e.target.value,
                                            )
                                          }
                                          placeholder="Enter miles"
                                          inputMode="decimal"
                                        />
                                        {errors[accordion.id]
                                          ?.scheduled_miles && (
                                          <span className="errors">
                                            {
                                              errors[accordion.id]
                                                .scheduled_miles
                                            }
                                          </span>
                                        )}
                                        <button
                                          className="btn btn-primary rounded-1 btn-sm mt-2"
                                          type="button"
                                          style={{
                                            background: "#31876f",
                                            border: "unset",
                                            height: "30px",
                                            color: "#fff",
                                            padding: "5px",
                                          }}
                                          onClick={handleCalculateLeg1Mileage}
                                          disabled={
                                            calculatingLeg1Mileage ||
                                            !accordion.pick_up_loc ||
                                            !accordion.drop_off_loc
                                          }
                                        >
                                          {calculatingLeg1Mileage
                                            ? "Calculating..."
                                            : "Calculate Mileage"}
                                        </button>
                                      </div>

                                      <div className="col-2">
                                        <label className="require-field">
                                          Appt. Time
                                        </label>
                                        <select
                                          name="appt_time"
                                          className="form-select"
                                          id="appt_time"
                                          onChange={handleInputChange}
                                        >
                                          <option value="">Select</option>
                                          {TIME_OPTIONS_5_MIN.map((t) => (
                                            <option key={t} value={t}>
                                              {t}
                                            </option>
                                          ))}
                                        </select>
                                        {errors.appt_time && (
                                          <span className="errors">
                                            {errors.appt_time}
                                          </span>
                                        )}
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )}

                            {/* First row for Ride ID field in Leg 2, 3, etc. (hidden for MA payer) */}
                            {accordion.id !== 1 && (
                              <div className="row mb-3">
                                <div className="col-2">
                                  <label>Assign Driver</label>
                                  <select
                                    className="form-select"
                                    value={accordion.assigned_driver ?? ""}
                                    onChange={(e) =>
                                      handleAccordianInputChange(
                                        accordion.id,
                                        "assigned_driver",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select Driver</option>
                                    {assignedDriver.map((driver, index) => (
                                      <option
                                        key={index}
                                        value={driver.driver_id}
                                      >
                                        {driver.driver_name
                                          ? driver.driver_name
                                          : driver.full_name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {isMAPayer && (
                                  <div className="col-2">
                                    <label className="require-field">
                                      Scheduled Miles
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name={`scheduled_miles_leg_${accordion.id}`}
                                      value={accordion.scheduled_miles ?? ""}
                                      onChange={(e) =>
                                        handleAccordianInputChange(
                                          accordion.id,
                                          "scheduled_miles",
                                          e.target.value,
                                        )
                                      }
                                      placeholder="Enter miles"
                                      inputMode="decimal"
                                    />
                                    {errors[accordion.id]?.scheduled_miles && (
                                      <span className="errors">
                                        {errors[accordion.id].scheduled_miles}
                                      </span>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                            {accordion.id !== 1 && !isMAPayer && (
                              <div className="row mb-3">
                                <div className="col-2">
                                  <label>Ride ID / Conf#</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={`ride_id_leg_${accordion.id}`}
                                    value={accordion.ride_id || ""}
                                    onChange={(e) =>
                                      handleAccordianInputChange(
                                        accordion.id,
                                        "ride_id",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Ride ID"
                                  />
                                  {errors[accordion.id]?.ride_id && (
                                    <span className="errors">
                                      {errors[accordion.id].ride_id}
                                    </span>
                                  )}
                                </div>
                                <div className="col-2">
                                  <label className="require-field">
                                    Scheduled Miles
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={`scheduled_miles_leg_${accordion.id}`}
                                    value={accordion.scheduled_miles ?? ""}
                                    onChange={(e) =>
                                      handleAccordianInputChange(
                                        accordion.id,
                                        "scheduled_miles",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter miles"
                                    inputMode="decimal"
                                  />
                                  {errors[accordion.id]?.scheduled_miles && (
                                    <span className="errors">
                                      {errors[accordion.id].scheduled_miles}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Second row for existing fields (Pick Up Time, Location, etc.) */}
                            <div className="row pickup-time align-items-c">
                              <div className="col-sm-12 col-md-8 col-lg-7 ps-2">
                                <div className="form-create-schedule">
                                  <div>
                                    <div>
                                      <label className="require-field">
                                        Pick Up Time
                                      </label>
                                      {/* <TimePicker time={pickUpTime} setTime={setPickUpTime} type='1' setErrors={setErrors} /> */}

                                      <select
                                        name="pick_up_time"
                                        className="form-select"
                                        id="pick_up_time"
                                        onChange={(e) =>
                                          handleAccordianInputChange(
                                            accordion.id,
                                            "pick_up_time",
                                            e.target.value,
                                          )
                                        }
                                      >
                                        <option value="">Select</option>
                                        <option value="Will Call">
                                          Will Call
                                        </option>
                                        {TIME_OPTIONS_5_MIN.map((t) => (
                                          <option key={t} value={t}>
                                            {t}
                                          </option>
                                        ))}
                                      </select>

                                      {errors[accordion.id]?.pick_up_time && (
                                        <span className="errors">
                                          {errors[accordion.id].pick_up_time}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <div>
                                    <label className="require-field">
                                      Pick Up Location
                                    </label>
                                    <select
                                      className="form-select"
                                      aria-label="Default select example"
                                      name="pick_up_loc"
                                      value={accordion.pick_up_loc}
                                      onChange={(e) => {
                                        handleAccordianInputChange(
                                          accordion.id,
                                          "pick_up_loc",
                                          e.target.value,
                                        );
                                        setSelectedPickUpLocations((prev) => ({
                                          ...prev,
                                          [accordion.id]: e.target.value, // Update state on change
                                        }));
                                        updateLocationTypes(
                                          accordion.id,
                                          "pickup",
                                          e.target.value,
                                        );
                                      }}
                                    >
                                      <option value="">Select</option>
                                      {uniqueAllLocations.map((option) => (
                                        <option
                                          key={option.loc_id}
                                          value={option.loc_id}
                                        >
                                          {[
                                            option?.loc_name,
                                            option?.loc_address,
                                            option?.loc_city,
                                            option.state?.state_name,
                                            option?.loc_zip,
                                          ]
                                            .filter(Boolean)
                                            .join(", ")}
                                        </option>
                                      ))}
                                    </select>
                                    {errors[accordion.id]?.pick_up_loc && (
                                      <span className="errors">
                                        {errors[accordion.id].pick_up_loc}
                                      </span>
                                    )}
                                    {locationErrors[accordion.id] && (
                                      <span className="text-danger">
                                        {locationErrors[accordion.id]}
                                      </span>
                                    )}
                                    {locationTypes[`${accordion.id}_pickup`] ? (
                                      <div
                                        className="has-location"
                                        style={{
                                          fontStyle: "italic",
                                          fontSize: "0.9em",
                                          color: "green",
                                          marginTop: "4px",
                                        }}
                                      >
                                        Location Type:{" "}
                                        {
                                          locationTypes[
                                            `${accordion.id}_pickup`
                                          ]
                                        }
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="align-self-end align-end d-flex gap-2">
                                    <PopupModal
                                      passId={
                                        selectedPassenger.value?.passenger
                                          ?.passenger_id ?? ""
                                      }
                                      title="Add PickUp Location"
                                      toSetValue={setSetValue}
                                      locType="1"
                                      setValue={setLocationValue}
                                      addValue={locationValue}
                                      filterCriteria={1}
                                      handleResetAddValue={handleResetAddValue}
                                    />
                                    {selectedPassenger.value?.passenger
                                      ?.passenger_id && (
                                      <IconButton
                                        aria-label="edit location"
                                        title="Edit Location"
                                        color="primary"
                                        onClick={() =>
                                          setEditLocationOpen(true)
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </div>

                                  <div>
                                    <div>
                                      <label className="require-field">
                                        Drop off Time
                                      </label>
                                      {/* <TimePicker time={dropOffTime} setTime={setDropOffTime} type='2' setErrors={setErrors} /> */}
                                      <select
                                        name="drop_off_time"
                                        className="form-select"
                                        id="drop_off_time"
                                        onChange={(e) =>
                                          handleAccordianInputChange(
                                            accordion.id,
                                            "drop_off_time",
                                            e.target.value,
                                          )
                                        }
                                      >
                                        <option value="">Select</option>
                                        <option value="Will Call">
                                          Will Call
                                        </option>
                                        {TIME_OPTIONS_5_MIN.map((t) => (
                                          <option key={t} value={t}>
                                            {t}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    {errors[accordion.id]?.drop_off_time && (
                                      <span className="errors">
                                        {errors[accordion.id].drop_off_time}
                                      </span>
                                    )}
                                  </div>
                                  <div>
                                    <label className="require-field">
                                      Drop off Location
                                    </label>
                                    <div>
                                      <select
                                        className="form-select"
                                        aria-label="Default select example"
                                        name="drop_off_loc"
                                        value={accordion.drop_off_loc}
                                        onChange={(e) => {
                                          handleAccordianInputChange(
                                            accordion.id,
                                            "drop_off_loc",
                                            e.target.value,
                                          );
                                          setSelectedPickUpLocations(
                                            (prev) => ({
                                              ...prev,
                                              [accordion.id]: e.target.value, // Update state on change
                                            }),
                                          );
                                          updateLocationTypes(
                                            accordion.id,
                                            "dropoff",
                                            e.target.value,
                                          );
                                        }}
                                      >
                                        <option value="">Select</option>
                                        {uniqueAllLocations.map((option) => (
                                          <option
                                            key={option.loc_id}
                                            value={option.loc_id}
                                          >
                                            {[
                                              option.loc_name,
                                              option.loc_address,
                                              option.state?.state_name,
                                              option.loc_city,
                                              option.loc_zip,
                                            ]
                                              .filter(Boolean)
                                              .join(", ")}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    {errors[accordion.id]?.drop_off_loc && (
                                      <span className="errors">
                                        {errors[accordion.id].drop_off_loc}
                                      </span>
                                    )}
                                    {locationTypes[
                                      `${accordion.id}_dropoff`
                                    ] ? (
                                      <div
                                        className="has-location"
                                        style={{
                                          fontStyle: "italic",
                                          fontSize: "14px",
                                          color: "green",
                                          marginTop: "4px",
                                        }}
                                      >
                                        Location Type:{" "}
                                        {
                                          locationTypes[
                                            `${accordion.id}_dropoff`
                                          ]
                                        }
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="align-self-end align-end d-flex gap-2">
                                    <PopupModal
                                      passId={
                                        selectedPassenger.value?.passenger
                                          ?.passenger_id ?? ""
                                      }
                                      title="Add DropOff Location"
                                      locType="2"
                                      toSetValue={setSetValue}
                                      setValue={setLocationValue}
                                      addValue={locationValue}
                                      filterCriteria={2}
                                      handleResetAddValue={handleResetAddValue}
                                    />
                                    {selectedPassenger.value?.passenger
                                      ?.passenger_id && (
                                      <IconButton
                                        aria-label="edit location"
                                        title="Edit Location"
                                        color="primary"
                                        onClick={() =>
                                          setEditLocationOpen(true)
                                        }
                                      >
                                        <EditIcon fontSize="small" />
                                      </IconButton>
                                    )}
                                  </div>
                                </div>
                                {!isMAPayer && null}
                              </div>
                            </div>
                          </div>
                        </AccordionDetails>
                      </Accordion>
                    ))}

                  {/* Submit button for all data */}
                  {!isMAPayer && null}

                  {/* Other Trip Details Section */}
                  <div style={{ marginTop: "20px" }}>
                    <p className="sub-title">Other Trip Details</p>
                    <div
                      className="other-options-container"
                      style={{
                        backgroundColor: "#e8f5e8",
                        padding: "20px",
                        borderRadius: "8px",
                        border: "1px solid #c3e6c3",
                      }}
                    >
                      <div className="row">
                        <div className="col-2">
                          <label>Deadhead Miles</label>
                          <input
                            type="number"
                            className="form-control"
                            name="deadhead_miles"
                            placeholder="Enter miles"
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="col-2">
                          <label>Is There Any Wait Time</label>
                          <div>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              onChange={handleInputChange}
                              name="is_wait"
                              value={isWait}
                            >
                              <option value="">Select</option>
                              <option value="0">No</option>
                              <option value="1">yes</option>
                            </select>
                          </div>
                          {errors.is_wait && (
                            <span className="errors">{errors.is_wait}</span>
                          )}
                        </div>

                        {isWait === "1" && ( // Show input fields only if "Yes" is selected
                          <>
                            <div className="col-1">
                              <label>Hour</label>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control"
                                placeholder="Hr"
                                name="hour"
                                onChange={handleInputChange}
                                value={
                                  isEditingWaitHour
                                    ? (scheduleDetails.hour ?? "")
                                    : String(
                                        scheduleDetails.hour ?? "",
                                      ).padStart(2, "0")
                                }
                                onFocus={(e) => {
                                  setIsEditingWaitHour(true);
                                  e.target.select();
                                }}
                                onBlur={() => {
                                  setIsEditingWaitHour(false);
                                  setScheduleDetails((prev) => {
                                    const raw = (prev.hour ?? "")
                                      .toString()
                                      .replace(/\D/g, "")
                                      .slice(0, 2);
                                    const num = raw === "" ? 0 : Number(raw);
                                    const clamped = Math.min(
                                      24,
                                      isNaN(num) ? 0 : num,
                                    );
                                    return {
                                      ...prev,
                                      hour: String(clamped).padStart(2, "0"),
                                    };
                                  });
                                }}
                                style={{ fontSize: "14px" }}
                              />
                              {errors.hour && (
                                <span className="errors">{errors.hour}</span>
                              )}
                            </div>
                            <div className="col-1">
                              <label>Minute</label>
                              <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="form-control"
                                placeholder="Min"
                                name="minute"
                                onChange={handleInputChange}
                                value={
                                  isEditingWaitMinute
                                    ? (scheduleDetails.minute ?? "")
                                    : String(
                                        scheduleDetails.minute ?? "",
                                      ).padStart(2, "0")
                                }
                                onFocus={(e) => {
                                  setIsEditingWaitMinute(true);
                                  e.target.select();
                                }}
                                onBlur={() => {
                                  setIsEditingWaitMinute(false);
                                  setScheduleDetails((prev) => {
                                    const raw = (prev.minute ?? "")
                                      .toString()
                                      .replace(/\D/g, "")
                                      .slice(0, 2);
                                    const num = raw === "" ? 0 : Number(raw);
                                    const clamped = Math.min(
                                      59,
                                      isNaN(num) ? 0 : num,
                                    );
                                    return {
                                      ...prev,
                                      minute: String(clamped).padStart(2, "0"),
                                    };
                                  });
                                }}
                                style={{ fontSize: "14px" }}
                              />
                              {errors.minute && (
                                <span className="errors">{errors.minute}</span>
                              )}
                            </div>
                          </>
                        )}

                        <div
                          className={`col-2 ${isWait === "0" ? "" : "col-2"}`}
                          style={{
                            paddingLeft: isWait === "1" ? "0px" : "5px",
                          }}
                        >
                          <label>Door Assist</label>
                          <div className="d-flex gap-1 align-items-center mt-2">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="door_assist"
                                id="door_assist_yes"
                                value="2"
                                onChange={handleInputChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="door_assist_yes"
                              >
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="door_assist"
                                id="door_assist_no"
                                value="1"
                                onChange={handleInputChange}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="door_assist_no"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>

                        <div
                          className={`col-2 ${isWait === "0" ? "" : "col-2"}`}
                        >
                          <label className="require-field">
                            Are there any companions traveling?
                          </label>
                          <div className="d-flex gap-3 align-items-center">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hasCompanions"
                                id="noCompanions"
                                value="No"
                                checked={hasCompanions === "No"}
                                onChange={(e) =>
                                  handleCompanionChange(e.target.value)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="noCompanions"
                              >
                                No
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="hasCompanions"
                                id="yesCompanions"
                                value="Yes"
                                checked={hasCompanions === "Yes"}
                                onChange={(e) =>
                                  handleCompanionChange(e.target.value)
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="yesCompanions"
                              >
                                Yes
                              </label>
                            </div>
                          </div>
                          {errors.has_companions && (
                            <span className="errors">
                              {errors.has_companions}
                            </span>
                          )}
                        </div>

                        {hasCompanions === "Yes" && (
                          <div className="col-2">
                            <label className="require-field">
                              Number of Companions
                            </label>
                            <div>
                              <input
                                type="text"
                                className="form-control"
                                id="companion_count"
                                name="companion_count"
                                value={companionCount}
                                placeholder="Companion count"
                                onChange={handleCompanionCountChange}
                                maxLength="2"
                              />
                              {errors.companion_count && (
                                <span className="errors">
                                  {errors.companion_count}
                                </span>
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row mt-3">
                        <div className="col-12">
                          <div className="client-notes">
                            <label>Notes</label>
                            <div>
                              <textarea
                                className="alert alert-light"
                                name="schedule_note"
                                role="alert"
                                style={{ width: "100%" }}
                                onChange={handleInputChange}
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <div
                  className="footer-content"
                  style={{
                    display: "flex",
                    gap: "10px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* <SaveButton type='submit' buttonTitle={'ADD SCHEDULE'}/> */}
                  {/* Add button component  */}
                  <button
                    className="btn btn-primary rounded-1"
                    type="button"
                    style={{
                      background: "#31876f",
                      border: "unset",
                      height: "38px",
                      color: "#fff",
                      padding: "7px",
                    }}
                    onClick={handleFormSubmit}
                    disabled={isAddingSchedule}
                  >
                    {isAddingSchedule ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        />
                        ADDING...
                      </>
                    ) : (
                      "ADD SCHEDULE"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </section>
        </div>
      </div>
      <div> {loading && <Loader />}</div>
      <ReusableModal
        open={editLocationOpen}
        onClose={() => setEditLocationOpen(false)}
        title="Edit Location"
        maxWidth="md"
      >
        <EditLocationContent
          passengerId={selectedPassenger.value?.passenger?.passenger_id ?? ""}
          onSaved={(updatedLocId) => {
            setEditLocationOpen(false);
            // Reload locations
            handleLocationSelect({ value: selectedPassenger.value }).then(
              () => {
                // After reload, sync the selects to ensure the updated location shows reflected data
                setAccordions((prev) =>
                  prev.map((acc) => ({
                    ...acc,
                    pick_up_loc:
                      String(acc.pick_up_loc) === String(updatedLocId)
                        ? updatedLocId
                        : acc.pick_up_loc,
                    drop_off_loc:
                      String(acc.drop_off_loc) === String(updatedLocId)
                        ? updatedLocId
                        : acc.drop_off_loc,
                  })),
                );
                // Recompute location type labels for all legs
                setAccordions((prev) => {
                  prev.forEach((a) => {
                    if (a.pick_up_loc)
                      updateLocationTypes(a.id, "pickup", a.pick_up_loc);
                    if (a.drop_off_loc)
                      updateLocationTypes(a.id, "dropoff", a.drop_off_loc);
                  });
                  return prev;
                });
              },
            );
            // Sync selects if edited loc is currently chosen
          }}
        />
      </ReusableModal>
    </>
  );
};
export default UpdatedSchedule;
